<template>
  <div class="main-template">
    <d-table
      v-if="tableReady"
      :data_object="data_object"
      :getFreshData="true"
      :linkClick="linkClick"
      :link="link"
      :itemsPerPage="15"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
      tableName="agents"
      :serverPagination="false"
      :showGroupBy="false"
      :sortDesc="true"
      :insertable="false"
      :noRefreshAfterUpload="true"
      :editRow="true"
      :addButtonCaption="addButtonCaption"
      :alwaysUpdate="true"
      :onDataReceived="onDataReceived"
      :editedItemTitle="editedItemTitle"
      :columnTool="true"
    />
  </div>
</template>

<script>
import * as fun from "../plugins/common";
export default {
  name: "Agents",
  components: {
    DTable: () => import("../components/Table.vue")
  },
  props: {},
  data() {
    return {
      tableKey: 0,
      tableReady: true,
      getFreshData: true,
      agents: true,

      data_object: {
        object_name: "agent",

        mobileBreakpoint: 0,
        all_records: true,

        table_title: "Agents",
        hasSearch: true
      },

      editedItemTitle: ["full_name"],
      searchableColumns: [],

      addButtonCaption: "Add Agent"
    };
  },
  mounted() {
    var that = this;
    this.$root.$on("mailSent", r => {
      console.log(r);
      if (r.obj.documentModel.type == "document") {
        var tbl = that.$refs.dTable;
        tbl.dObject.model.date_sent = fun.formatDateTime(new Date());
        tbl.validateAndSave();
      }
    });
    this.$root.$on("customBtnClick", r => {
      console.log(r);
    });
    // selectRoom
  },
  beforeDestroy() {},
  methods: {
    onDataReceived(d) {
      var doc = fun.deepFind(d, "schema.properties.invoice.table_properties.schema.properties.invoice_body");
      if (doc) {
        doc["v-bind"].qry = {
          agent_trips: {
            $elemMatch: {
              date: {
                $gte: 'formatDate(f.date_range.split("-")[0], true,false,true)',
                $lte: 'formatDate(f.date_range.split("-")[1], true,false,true)'
              }
            }
          }
        };
      }

      // doc["v-bind"].qry = JSON.stringify(qry);

      d.table.forEach(r => {
        if (typeof r.contact == "object" && !Array.isArray(r.contact)) {
          r.contact = [r.contact];
        }
      });
      d.model = d.table;
      return d;
    }
  }
};
</script>

<style lang="css" scoped></style>
